module.exports = __webpack_public_path__ + "static/media/requests.aa0bc7a0.png";